export default __webpack_public_path__ + "static/Certificat_F0411-83c95622f5ffb0d247dbd09e6cf19a2c.pdf";